<template>
  <div class="main-container">
    <tl-header type="h3" class="head">Employee Data</tl-header>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="successMsg"
      btnText="Back"
      @back="(val) => (showSuccessMsg = val)"
    />
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <dataTableHsbc :columnData="PaymentColums" :columnTableData="approvedData">
      <template v-slot="slotprops">
        <p v-if="slotprops.value.column.key == 'slno'">
          {{ slotprops.value.record.slNo }}
        </p>
        <p v-if="slotprops.value.column.key == 'description'">
          {{ slotprops.value.record.comment }}
        </p>
        <btn
          class="button"
          v-if="slotprops.value.column.key == 'reportDownload'"
          text="Download Report"
          type="secondary"
          @click="downloadReportByBatchId(slotprops.value.record)"
        />
        <div v-if="slotprops.value.column.key == 'action'" class="calculate">
          <button
            :disabled="slotprops.value.record.batchPaymentStatus =='PAYMENT INITIATED'||slotprops.value.record.batchPaymentStatus =='PAYMENT REJECTED'?true:false"
            @click="postApprovedStatus(slotprops.value.record, false)"
            class="export-button"
          >
            Reject
          </button>
          <button
            :disabled="slotprops.value.record.batchPaymentStatus =='PAYMENT INITIATED'|| slotprops.value.record.batchPaymentStatus =='PAYMENT REJECTED'?true:false"
            @click="postApprovedStatus(slotprops.value.record, true)"
            class="export-button"
          >
            Approve
          </button>
        </div>
        <p v-if="slotprops.value.column.key == 'paymentStatus'">
          {{ slotprops.value.record.batchPaymentStatus }}
        </p>
      </template></dataTableHsbc
    >
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import dataTableHsbc from "./dataTableHsbc.vue";
import * as XLSX from "xlsx"
const crypto = require("crypto");
export default {
  components: {
    dataTableHsbc,
  },
  data() {
    return {
      PaymentColums: [
        { label: "SlNo", key: "slno", style: "width:4%" },
        { label: "Payment Instruction", key: "description" },
        { label: "Report Download", key: "reportDownload" },
        { label: "Action", key: "action" },
        { label: "Payment Status", key: "paymentStatus" },
      ],
      ipAddress: "",
      showSuccessMsg: false,
      toast: false,
      successMsg: "",
      errMessage: "",
      approvedData: [],
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
  },
  mounted() {
    this.fetchApprovedDetails();
  },
  activated(){
    this.fetchApprovedDetails();
  },
  methods: {
    ...mapActions({
      act_hsbc_approved_payment_Details:
        "dashboard/hsbcPaymentSetting/approvedPaymentDetails",
      act_hsbc_approved_status:
        "dashboard/hsbcPaymentSetting/postApprovedPaymentStatus",
    }),

    async fetchApprovedDetails() {
      try {
        let payload = {
          legalEntityId:this.leId
        }
        let data = await this.encryptData(payload);
        let res = await this.act_hsbc_approved_payment_Details(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data));
        console.log(apiResponse)
         for(let i in apiResponse.data){
          apiResponse.data[i].slNo = +i+1;
         }
        this.approvedData=apiResponse.data
      } catch {

      }
    },
    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString("hex");
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv("aes-256-cbc", key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final(),
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString("base64"),
        };
      } catch (err) {
        throw err;
      }
    },

    async decrypt(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv(
          "aes-256-cbc",
          key,
          payload.iv
        );
        const decrypted = Buffer.concat([
          decipher.update(payload.encryptedPacket, "base64"),
          decipher.final(),
        ]);
        return decrypted.toString();
      } catch (error) {
      }
    },
    async downloadReportByBatchId(res){
        try{
          let batchIdClicked = res.batchId
          console.log(this.approvedData)
           for(let i=0;i<=this.approvedData.length;i++){
             if(this.approvedData[i].batchId == batchIdClicked ){
                 let reportArray=[] 
                 console.log(this.approvedData[i].transactions)
                 reportArray.push(this.approvedData[i].transactions)
                    this.downloadReport(reportArray)
                    console.log(reportArray)
             }
             
           }
        }catch(err){

        }
        
    },
    async downloadReport(res){
      try{
        const data=XLSX.utils.json_to_sheet(res[0])
      const wb=XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb,data,'data')
      XLSX.writeFile(wb,`${res[0][0].clientName}.xlsx`)
      }
      catch(err){
         console.log(err)
      }
    },
    async postApprovedStatus(value, status) {
      try {
        let empId = localStorage.getItem("employeeId");
        let promiseIP = await fetch("https://api.ipify.org?format=json")
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            return data.ip;
          });
        let statusPayload = {
          legalEntityId: this.leId,
          batchId: value.batchId,
          approvedUserId: empId,
          approvedUserIp: promiseIP,
          batchStatus: status,
        };
        let data = await this.encryptData(statusPayload);
        let res = await this.act_hsbc_approved_status(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data)); 
        console.log(apiResponse)
        if (apiResponse.success) {
          (this.showSuccessMsg = true), (this.successMsg = apiResponse.message);
          this.fetchApprovedDetails()
        }
      } catch (err) {
        (this.toast = true), (this.errMessage = err.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.button {
  padding: 10px;
}
.buttonGroup {
  display: flex;
}
.calculate {
  display: flex;
  gap: 20px;
}
.export-button {
  background-color: rgb(147, 226, 222);
  color: black;
  width: 6rem;
}
h3 {
  margin-left: 30px;
}
</style>
